export default "__VITE_ASSET__D6M3kYyK__"